import React from 'react';
import { connect } from 'react-redux';

import { TextAreaBlock } from '../../../LocationBlock/TextAreaBlock';
import {
  filterLabels,
  AdvancedTargetingOptionKeys,
} from '../../../../../../store/advancedTargeting/constants';
import { AppState } from '../../../../../../models/Store';
import { CampaignInfoField } from '../../../../../../models/CampaignInfoFields';
import { ServerErrorMessage } from '../../../../../../components/ServerErrorMessage';

interface Props {
  filter: AdvancedTargetingOptionKeys;
  handleChange: (param: string) => void;
  handleCSVUpload: (param: FileList) => void;
  selectedValue?: string;
  uiNoteTooltip?: string;
}

const FilterButtonComponent = (props: Props) => {
  const { filter, handleChange, handleCSVUpload, selectedValue, uiNoteTooltip } = props;
  const label = filterLabels[filter];

  return (
    <div data-qa="381" className="col-5 pl-0">
      <TextAreaBlock
        value={selectedValue || ''}
        onChanged={handleChange}
        onFileUploaded={handleCSVUpload}
        label={label}
        placeholder={`Please enter ${label}`}
        id={filter}
        uiNoteTooltip={uiNoteTooltip}
      />
      <ServerErrorMessage errorKey={filter} />
    </div>
  );
};

FilterButtonComponent.defaultProps = {
  selectedValue: '',
};

const mapStateToProps = (state: AppState, props: Props) => ({
  selectedValue: state.advancedTargeting.sidebarCampaignInfo[CampaignInfoField[props.filter]],
});

export const FilterButton = connect(mapStateToProps)(FilterButtonComponent);
